
export function enCountries() {
  const countries = [
    {
      region: 'Avrupa',
      country: 'Germany'
    },
    {
      region: 'Asya',
      country: 'UAE (United Arab Emirates)'
    },
    {
      region: 'Avrupa',
      country: 'United Kingdom (Great Britain / England) and Northern Ireland'
    },
    {
      region: 'Avrupa',
      country: 'Italy'
    },
    {
      region: 'Avrupa',
      country: 'Republic of Kosovo'
    },
    {
      region: 'Kuzey Amerika',
      country: 'USA (United States of America)'
    },
    {
      region: 'Kuzey Amerika',
      country: 'US Virgin Islands'
    },
    {
      region: 'Asya',
      country: 'Afghanistan'
    },
    {
      region: 'Avrupa',
      country: 'Andorra'
    },
    {
      region: 'Afrika',
      country: 'Angola'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Antigua and Barbuda'
    },
    {
      region: 'Güney Amerika',
      country: 'Argentina'
    },
    {
      region: 'Avrupa',
      country: 'Albania'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Aruba'
    },
    {
      region: 'Okyanusya',
      country: 'Australia'
    },
    {
      region: 'Avrupa',
      country: 'Austria'
    },
    {
      region: 'Asya',
      country: 'Azerbaijan'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Bahamas'
    },
    {
      region: 'Asya',
      country: 'Bahrain'
    },
    {
      region: 'Asya',
      country: 'Bangladesh'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Barbados'
    },
    {
      region: 'Avrupa',
      country: 'Belarus'
    },
    {
      region: 'Avrupa',
      country: 'Belgium'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Belize'
    },
    {
      region: 'Afrika',
      country: 'Benin'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Bermuda'
    },
    {
      region: 'Kuzey Amerika',
      country: 'BES Islands (Bonaire, Sint Eustatius, and Saba)'
    },
    {
      region: 'Asya',
      country: 'Bhutan'
    },
    {
      region: 'Asya',
      country: 'Myanmar (Burma)'
    },
    {
      region: 'Güney Amerika',
      country: 'Bolivia'
    },
    {
      region: 'Avrupa',
      country: 'Bosnia and Herzegovina'
    },
    {
      region: 'Afrika',
      country: 'Botswana'
    },
    {
      region: 'Güney Amerika',
      country: 'Brazil'
    },
    {
      region: 'Asya',
      country: 'Brunei'
    },
    {
      region: 'Avrupa',
      country: 'Bulgaria'
    },
    {
      region: 'Afrika',
      country: 'Burkina Faso'
    },
    {
      region: 'Afrika',
      country: 'Burundi'
    },
    {
      region: 'Afrika',
      country: 'Chad'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Cayman Islands'
    },
    {
      region: 'Avrupa',
      country: 'Czech Republic'
    },
    {
      region: 'Afrika',
      country: 'Algeria'
    },
    {
      region: 'Afrika',
      country: 'Djibouti'
    },
    {
      region: 'Asya',
      country: 'China'
    },
    {
      region: 'Avrupa',
      country: 'Denmark'
    },
    {
      region: 'Afrika',
      country: 'Democratic Republic of the Congo'
    },
    {
      region: 'Asya',
      country: 'East Timor'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Dominican Republic'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Dominica'
    },
    {
      region: 'Güney Amerika',
      country: 'Ecuador'
    },
    {
      region: 'Afrika',
      country: 'Equatorial Guinea'
    },
    {
      region: 'Kuzey Amerika',
      country: 'El Salvador'
    },
    {
      region: 'Asya',
      country: 'Indonesia'
    },
    {
      region: 'Afrika',
      country: 'Eritrea'
    },
    {
      region: 'Asya',
      country: 'Armenia'
    },
    {
      region: 'Avrupa',
      country: 'Estonia'
    },
    {
      region: 'Afrika',
      country: 'Ethiopia'
    },
    {
      region: 'Avrupa',
      country: 'Faroe Islands'
    },
    {
      region: 'Afrika',
      country: 'Morocco'
    },
    {
      region: 'Okyanusya',
      country: 'Fiji'
    },
    {
      region: 'Afrika',
      country: 'Ivory Coast'
    },
    {
      region: 'Asya',
      country: 'Philippines'
    },
    {
      region: 'Asya',
      country: 'Palestine'
    },
    {
      region: 'Avrupa',
      country: 'Finland'
    },
    {
      region: 'Avrupa',
      country: 'France'
    },
    {
      region: 'Güney Amerika',
      country: 'French Guiana'
    },
    {
      region: 'Afrika',
      country: 'Gabon'
    },
    {
      region: 'Afrika',
      country: 'Gambia'
    },
    {
      region: 'Afrika',
      country: 'Ghana'
    },
    {
      region: 'Afrika',
      country: 'Guinea'
    },
    {
      region: 'Afrika',
      country: 'Guinea-Bissau'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Grenada'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Greenland'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Guadeloupe'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Guatemala'
    },
    {
      region: 'Afrika',
      country: 'South Africa'
    },
    {
      region: 'Asya',
      country: 'South Korea'
    },
    {
      region: 'Asya',
      country: 'Georgia'
    },
    {
      region: 'Güney Amerika',
      country: 'Guyana'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Haiti'
    },
    {
      region: 'Asya',
      country: 'India'
    },
    {
      region: 'Avrupa',
      country: 'Croatia'
    },
    {
      region: 'Avrupa',
      country: 'Netherlands'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Honduras'
    },
    {
      region: 'Asya',
      country: 'Iraq'
    },
    {
      region: 'Asya',
      country: 'Iran'
    },
    {
      region: 'Avrupa',
      country: 'Ireland'
    },
    {
      region: 'Avrupa',
      country: 'Spain'
    },
    {
      region: 'Asya',
      country: 'Israel'
    },
    {
      region: 'Avrupa',
      country: 'Sweden'
    },
    {
      region: 'Avrupa',
      country: 'Switzerland'
    },
    {
      region: 'Avrupa',
      country: 'Iceland'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Jamaica'
    },
    {
      region: 'Asya',
      country: 'Japan'
    },
    {
      region: 'Asya',
      country: 'Cambodia'
    },
    {
      region: 'Afrika',
      country: 'Cameroon'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Canada'
    },
    {
      region: 'Avrupa',
      country: 'Montenegro'
    },
    {
      region: 'Asya',
      country: 'Qatar'
    },
    {
      region: 'Asya',
      country: 'Kazakhstan'
    },
    {
      region: 'Afrika',
      country: 'Kenya'
    },
    {
      region: 'Okyanusya',
      country: 'Kiribati'
    },
    {
      region: 'Asya',
      country: 'Kyrgyzstan'
    },
    {
      region: 'Güney Amerika',
      country: 'Colombia'
    },
    {
      region: 'Afrika',
      country: 'Comoros'
    },
    {
      region: 'Afrika',
      country: 'Republic of the Congo'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Costa Rica'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Cuba'
    },
    {
      region: 'Asya',
      country: 'Kuwait'
    },
    {
      region: 'Asya',
      country: 'North Korea'
    },
    {
      region: 'Asya',
      country: 'Laos'
    },
    {
      region: 'Afrika',
      country: 'Lesotho'
    },
    {
      region: 'Avrupa',
      country: 'Latvia'
    },
    {
      region: 'Afrika',
      country: 'Liberia'
    },
    {
      region: 'Afrika',
      country: 'Libya'
    },
    {
      region: 'Avrupa',
      country: 'Liechtenstein'
    },
    {
      region: 'Avrupa',
      country: 'Lithuania'
    },
    {
      region: 'Asya',
      country: 'Lebanon'
    },
    {
      region: 'Avrupa',
      country: 'Luxembourg'
    },
    {
      region: 'Avrupa',
      country: 'Hungary'
    },
    {
      region: 'Afrika',
      country: 'Madagascar'
    },
    {
      region: 'Avrupa',
      country: 'North Macedonia'
    },
    {
      region: 'Afrika',
      country: 'Malawi'
    },
    {
      region: 'Asya',
      country: 'Maldives'
    },
    {
      region: 'Asya',
      country: 'Malaysia'
    },
    {
      region: 'Afrika',
      country: 'Mali'
    },
    {
      region: 'Avrupa',
      country: 'Malta'
    },
    {
      region: 'Okyanusya',
      country: 'Marshall Islands'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Martinique'
    },
    {
      region: 'Afrika',
      country: 'Mauritania'
    },
    {
      region: 'Afrika',
      country: 'Mauritius'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Mexico'
    },
    {
      region: 'Okyanusya',
      country: 'Micronesia'
    },
    {
      region: 'Afrika',
      country: 'Egypt'
    },
    {
      region: 'Asya',
      country: 'Mongolia'
    },
    {
      region: 'Avrupa',
      country: 'Moldova'
    },
    {
      region: 'Avrupa',
      country: 'Monaco'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Montserrat'
    }, {
      region: 'Afrika',
      country: 'Morocco'
    },
    {
      region: 'Afrika',
      country: 'Mozambique'
    },
    {
      region: 'Afrika',
      country: 'Namibia'
    },
    {
      region: 'Okyanusya',
      country: 'Nauru'
    },
    {
      region: 'Asya',
      country: 'Nepal'
    },
    {
      region: 'Afrika',
      country: 'Niger'
    },
    {
      region: 'Afrika',
      country: 'Nigeria'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Nicaragua'
    },
    {
      region: 'Avrupa',
      country: 'Norway'
    },
    {
      region: 'Afrika',
      country: 'Central African Republic'
    },
    {
      region: 'Asya',
      country: 'Oman'
    },
    {
      region: 'Asya',
      country: 'Pakistan'
    },
    {
      region: 'Okyanusya',
      country: 'Palau'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Panama'
    },
    {
      region: 'Okyanusya',
      country: 'Papua New Guinea'
    },
    {
      region: 'Güney Amerika',
      country: 'Paraguay'
    },
    {
      region: 'Güney Amerika',
      country: 'Peru'
    },
    {
      region: 'Avrupa',
      country: 'Poland'
    },
    {
      region: 'Avrupa',
      country: 'Portugal'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Puerto Rico'
    },
    {
      region: 'Avrupa',
      country: 'Romania'
    },
    {
      region: 'Afrika',
      country: 'Rwanda'
    },
    {
      region: 'Avrupa',
      country: 'Russia'
    },
    {
      region: 'Afrika',
      country: 'Sahrawi Arab Democratic Republic'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Saint Kitts and Nevis'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Saint Lucia'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Saint Vincent and the Grenadines'
    },
    {
      region: 'Afrika',
      country: 'Sao Tome and Principe'
    },
    {
      region: 'Afrika',
      country: 'Senegal'
    },
    {
      region: 'Afrika',
      country: 'Seychelles'
    },
    {
      region: 'Afrika',
      country: 'Sierra Leone'
    },
    {
      region: 'Güney Amerika',
      country: 'Chile'
    },
    {
      region: 'Asya',
      country: 'Singapore'
    },
    {
      region: 'Avrupa',
      country: 'Slovakia'
    },
    {
      region: 'Avrupa',
      country: 'Slovenia'
    },
    {
      region: 'Afrika',
      country: 'Somalia'
    },
    {
      region: 'Asya',
      country: 'South Korea'
    },
    {
      region: 'Afrika',
      country: 'South Sudan'
    },
    {
      region: 'Avrupa',
      country: 'Spain'
    },
    {
      region: 'Asya',
      country: 'Sri Lanka'
    },
    {
      region: 'Afrika',
      country: 'Sudan'
    },
    {
      region: 'Güney Amerika',
      country: 'Suriname'
    },
    {
      region: 'Afrika',
      country: 'Swaziland'
    },
    {
      region: 'Avrupa',
      country: 'Sweden'
    },
    {
      region: 'Avrupa',
      country: 'Switzerland'
    },
    {
      region: 'Asya',
      country: 'Syria'
    }, {
      region: 'Asya',
      country: 'Taiwan'
    },
    {
      region: 'Asya',
      country: 'Tajikistan'
    },
    {
      region: 'Afrika',
      country: 'Tanzania'
    },
    {
      region: 'Asya',
      country: 'Thailand'
    },
    {
      region: 'Afrika',
      country: 'Togo'
    },
    {
      region: 'Okyanusya',
      country: 'Tonga'
    },
    {
      region: 'Kuzey Amerika',
      country: 'Trinidad and Tobago'
    },
    {
      region: 'Afrika',
      country: 'Tunisia'
    },
    {
      region: 'Avrupa',
      country: 'Turkey'
    },
    {
      region: 'Asya',
      country: 'Turkmenistan'
    },
    {
      region: 'Okyanusya',
      country: 'Tuvalu'
    },
    {
      region: 'Afrika',
      country: 'Uganda'
    },
    {
      region: 'Avrupa',
      country: 'Ukraine'
    },
    {
      region: 'Asya',
      country: 'United Arab Emirates'
    },
    {
      region: 'Avrupa',
      country: 'United Kingdom'
    },
    {
      region: 'Kuzey Amerika',
      country: 'United States'
    },
    {
      region: 'Güney Amerika',
      country: 'Uruguay'
    },
    {
      region: 'Asya',
      country: 'Uzbekistan'
    },
    {
      region: 'Okyanusya',
      country: 'Vanuatu'
    },
    {
      region: 'Güney Amerika',
      country: 'Venezuela'
    },
    {
      region: 'Asya',
      country: 'Vietnam'
    },
    {
      region: 'Asya',
      country: 'Yemen'
    },
    {
      region: 'Okyanusya',
      country: 'Zambia'
    },
    {
      region: 'Afrika',
      country: 'Zimbabwe'
    }
  ];

  return countries;
}



// WEBPACK FOOTER //
// ./src/constants/i18Util.js